import { makeStyles } from '@material-ui/core/styles';
import color from '@material-ui/core/colors/amber';

export const useStyles = makeStyles(theme=>({

    root: {
        minWidth: 275,
        width: '30%',
        position: 'absolute',
        top: '6%',
        left: '67%',   
        transition: '0.4s ease-out',
        textAlign: 'justify',
        boxShadow: '0px 0px 0px 0px',
        borderRadius: 41,
        ['@media (max-width: 2000px)'] :{  //web
            top: '13%',
        },
        ['@media (max-width: 1700px)'] :{  //web
            top: '11%',
        },
        ['@media (max-width: 1600px)'] :{  //web
            top: '9%',
        },
        ['@media (max-width: 1500px)'] :{  //web
            top: '7%',
            left: '69',
            width: '26%',   
        },
        ['@media (max-width:1366px)']:{ // web
            top: '6%',
        },
        ['@media (max-width:1280px)']:{ // web
            top: '8%',
        },
        ['@media (max-width:1030px)']:{ // web
            top: '10%',
            width: '30%',
        },
      },
      bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
      },
      title: {
        fontSize: 14,
      },
      pos: {
        transition: '0.4s ease-out',
        marginBottom: 12,
        ['@media (max-width: 2000px)'] :{  //web            
            fontSize: '1.1rem',
        },
        ['@media (max-width: 1500px)'] :{  //web
            fontSize: '0.9rem',
        },
        ['@media (max-width:1366px)']:{ // web
            fontSize: '0.8rem',
        },
        ['@media (max-width:1280px)']:{ // web
        },
        ['@media (max-width:1030px)']:{ // web
        },

      },

      note:{
          fontWeight: 800,
          
      }
}))